module.exports = __webpack_public_path__ + "f3759a03286ecc146abdc93c512c37d8.png";